import { gsap } from "@gsap";
import { createSlider } from "../../../../assets/js/slider.js";

function initCursor(layout) {
	const area = layout.querySelector(".photo-swiper");
	const cursor = layout.querySelector(".photo-cursor");
	if (!area || !cursor) return;

	gsap.matchMedia().add("(hover: hover) and (pointer: fine)", () => {
		area.classList.add("has-cursor");
		const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		const duration = reduce ? 0 : 0.35;
		const x = gsap.quickTo(cursor, "x", { duration, ease: "power3.out" });
		const y = gsap.quickTo(cursor, "y", { duration, ease: "power3.out" });

		const move = (event) => {
			const box = area.getBoundingClientRect();
			x(event.clientX - box.left);
			y(event.clientY - box.top);
		};
		const enter = (event) => {
			const box = area.getBoundingClientRect();
			gsap.set(cursor, { x: event.clientX - box.left, y: event.clientY - box.top });
			gsap.to(cursor, { autoAlpha: 1, scale: 1, duration: reduce ? 0 : 0.3, ease: "power2.out" });
		};
		const leave = () => gsap.to(cursor, { autoAlpha: 0, scale: 0.6, duration: reduce ? 0 : 0.3, ease: "power2.out" });
		const down = () => gsap.to(cursor, { scale: 0.85, duration: 0.15 });
		const up = () => gsap.to(cursor, { scale: 1, duration: 0.15 });

		gsap.set(cursor, { autoAlpha: 0, scale: 0.6, xPercent: -50, yPercent: -50 });
		area.addEventListener("pointermove", move);
		area.addEventListener("pointerenter", enter);
		area.addEventListener("pointerleave", leave);
		area.addEventListener("pointerdown", down);
		area.addEventListener("pointerup", up);

		return () => {
			area.classList.remove("has-cursor");
			area.removeEventListener("pointermove", move);
			area.removeEventListener("pointerenter", enter);
			area.removeEventListener("pointerleave", leave);
			area.removeEventListener("pointerdown", down);
			area.removeEventListener("pointerup", up);
		};
	});
}

function initPhotoSlider() {
	document.querySelectorAll(".photo_slider-layout").forEach((layout) => {
		createSlider(layout, ".photo-swiper");
		initCursor(layout);
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initPhotoSlider);
} else {
	initPhotoSlider();
}
